import { render, staticRenderFns } from "./BannerCreateCreative.vue?vue&type=template&id=5b2fcb89&lang=pug"
import script from "./BannerCreateCreative.vue?vue&type=script&lang=js"
export * from "./BannerCreateCreative.vue?vue&type=script&lang=js"
import style0 from "./BannerCreateCreative.vue?vue&type=style&index=0&id=5b2fcb89&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports